import { render, staticRenderFns } from "./ProgressBar2.vue?vue&type=template&id=d84be08e&scoped=true&lang=pug&"
import script from "./ProgressBar2.vue?vue&type=script&lang=js&"
export * from "./ProgressBar2.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBar2.vue?vue&type=style&index=0&id=d84be08e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84be08e",
  null
  
)

export default component.exports